<template>
  <v-row>
    <v-col cols="12">
      <hosting-password :hostingid="hosting.id" :title="`Change Password for ${hostingDomain}:`">
        <template #before-password>
          <v-col cols="12">
            <p class="mb-0">This will change the password for <b>{{ hostingDomain }}</b>.</p>
          </v-col>
        </template>
      </hosting-password>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import HostingPassword from '@/components/Services/Hosting/HostingPassword'

export default {
  name: 'PasswordView',
  components: {
    HostingPassword
  },
  computed: {
    ...mapGetters(['hosting', 'hosting_detail']),
    hostingDomain () {
      return this.hosting_detail.accountsummary?.domain || this.hosting.domain
    },
  }
}
</script>
